'use strict';

var NewCalibrationAnalysisDirective = function NewCalibrationAnalysisDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calibration-analysis-toolbar.html'),
    controller: 'NewCalibrationAnalysisToolbarController'
  };
};
module.exports = NewCalibrationAnalysisDirective;